import * as types from '@/store/mutation-types'
import api from '@/services/api/adminDash'
import { handleError } from '@/utils/utils.js'
import { checkIfTokenNeedsRefresh } from '@/utils/utils.js'

const getters = { // ANALISAR
  onlineUsers: state => state.onlineUsers,
  totalOnlineUsers: state => state.totalOnlineUsers,
  multiAxisChart: state => state.multiAxisChart,
  donutChart: state => state.donutChart,
  totalPageViews: state => state.totalPageViews,
  lastConnections: state => state.lastConnections
}

const actions = {
  getOnlineUsers({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api
        .getOnlineUsers(payload)
        .then(response => {
          if (response.status === 200) {
            commit(types.ONLINE_USERS, response.data.docs)
            commit(types.TOTAL_ONLINE_USERS, response.data.docs.totalDocs)
            resolve()
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },
  getCharts({ commit }, payload) {
    checkIfTokenNeedsRefresh()
    return new Promise((resolve, reject) => {
      commit(types.SHOW_TOP_LOADING, true)
      api
        .getCharts(payload)
        .then(response => {
          if (response.status === 200) {
            commit(types.MULTI_AXIS_CHART, response.data.acessos)
            commit(types.DONUT_CHART, response.data.semana)
            commit(types.TOTAL_PAGE_VIEWS, response.data.totalPageviews)
            commit(types.SHOW_TOP_LOADING, false)
            resolve()

          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },
  getLastConnections({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api
        .getLastConnections(payload)
        .then(response => {
          if (response.status === 200) {

            commit(types.LAST_CONNECTIONS, response.data.docs)
            resolve()
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  }
}

const mutations = {
  [types.ONLINE_USERS](state, onlineUsers) {
    state.onlineUsers = onlineUsers
  },
  [types.TOTAL_ONLINE_USERS](state, value) {
    state.totalOnlineUsers = value
  },
  [types.MULTI_AXIS_CHART](state, array) {
    state.multiAxisChart = array
  },
  [types.DONUT_CHART](state, array) {
    state.donutChart = array
  },
  [types.TOTAL_PAGE_VIEWS](state, value) {
    state.totalPageViews = value
  },
  [types.LAST_CONNECTIONS](state, lastConnections) {
    state.lastConnections = lastConnections
  }
}

const state = {
  onlineUsers: [],
  totalOnlineUsers: 0,
  multiAxisChart: [],
  donutChart: [],
  totalPageViews: 0,
  lastConnections: []
}

export default {
  state,
  getters,
  actions,
  mutations
}
